/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import queryString from "utils/queryString";
import { getTarget } from "services/target.routes";
import React from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import Loading from "components/Loading";
import TargetTable from "./TargetTable";
import { toast } from "react-toastify";
import ModalUI from "components/ModalUI";

export default function TargetModal({ modalInfo, closeModal }) {
    const [cursor, setCursor] = useState(null);
    const [page, setPage] = useState(0);
    const [hasMore, setHasMore] = useState(false);
    const [loading, setLoading] = useState(false);
    const [target, setTarget] = useState([])

    useEffect(() => {
        if (modalInfo?.userId) {
            setLoading(true);
            let query = {
                cursor: cursor === null ? null : cursor,
                per_page: 25,
                user_id: modalInfo?.userId,
                with_ghollak: 1,
                with_category: 1,
                admin: 1
            }

            getTarget(queryString(query), (isOk, data) => {
                setLoading(false);
                if (!isOk) {
                    return toast.error(data.message)
                } else {
                    if (page !== 0) {
                        setTarget((prev) => ([...prev, ...data.data]));
                    } else {
                        setTarget(data.data);
                    }
                    setCursor(data.meta.next_cursor === null ? '' : data.meta.next_cursor);
                    setHasMore(data.meta.next_cursor !== null);
                }
            })
        }
    }, [page]);

    const fetchMoreData = () => {
        if (loading) return;
        if (hasMore) {
            setPage(prevPage => prevPage + 1)
        }
    }

    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px", minHeight: "500px" }}>
            <Loading loading={loading} />
            <InfiniteScroll dataLength={target.length} next={fetchMoreData} height={450} hasMore={hasMore}>
                <TargetTable data={target} />
            </InfiniteScroll>
        </ModalUI>
    )
}